function createCustomListFormatter({
  locale = 'en-AU',
  type = 'conjunction',
  style = 'short',
  transformFn
} = {}) {
  const listFormatter = new Intl.ListFormat(locale, { type, style });

  return new Proxy(listFormatter, {
    get(target, prop, receiver) {
      if (prop === 'format') {
        return (list) => {
          let parts = receiver.formatToParts(list);

          if (typeof transformFn === 'function') {
            try {
              let result = transformFn(parts, target.resolvedOptions());

              if (typeof result === 'string') {
                return result;
              }

              if (!Array.isArray(result)) {
                throw new Error(
                  `transformFn expected returned value to be of type "string" or "array" but received ${typeof result}`
                );
              }

              parts = result;
            } catch (error) {
              console.error(error);
            }
          }

          return parts.map((part) => part.value || part).join('');
        };
      }

      if (prop === 'formatToParts') {
        const { type, style, locale } = target.resolvedOptions();

        if (
          locale.startsWith('en') &&
          type === 'conjunction' &&
          style !== 'long'
        ) {
          return (list) => {
            return target.formatToParts(list).map((part) => {
              const { type, value } = part;

              if (type === 'literal') {
                return {
                  type,
                  value: value.replace(/\band\b/, '&')
                };
              }

              return part;
            });
          };
        }
      }

      const value = Reflect.get(target, prop, receiver);

      return typeof value === 'function' ? value.bind(target) : value;
    }
  });
}

function formatList(list = [], formatterOptions = {}) {
  return createCustomListFormatter(formatterOptions).format(list);
}

module.exports = Object.assign(formatList, {
  formatList,
  createCustomListFormatter
});
